export default __webpack_public_path__ + "static/media/logo.8549ac09.svg";